import React from "react";

/** Cyan background with an isometric 3-D delivery box */
export const OperationalZoneIcon: React.FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#0891B2" />
    {/* Top face */}
    <path d="M20 8 L31 13.5 L20 19 L9 13.5 Z" fill="#F5D0A9" />
    {/* Left face */}
    <path d="M9 13.5 L20 19 L20 33 L9 27.5 Z" fill="#E8B88A" />
    {/* Right face */}
    <path d="M31 13.5 L20 19 L20 33 L31 27.5 Z" fill="#C4935A" />
    {/* Tape / crease lines */}
    <line x1="20" y1="8"    x2="20" y2="33"   stroke="white" strokeWidth="1.5" strokeOpacity="0.55" strokeLinecap="round" />
    <line x1="9"  y1="13.5" x2="31" y2="13.5" stroke="white" strokeWidth="1"   strokeOpacity="0.40" strokeLinecap="round" />
  </svg>
);
